import { prepareMoviesData } from '../../utils/prepareMoviesData';
import { getMoviesJsonForEnUs } from '../../utils/getMoviesJsonForEnUs';
import spanishMoviesJSON from './spanishMovies.data.json';
import abreLosOjosImageUrl from './assets/abre-los-ojos.jpg';
import celda211ImageUrl from './assets/celda-211.jpg';
import elHijoDeLaNoviaImageUrl from './assets/el-hijo-de-la-novia.jpg';
import elLaberintoDelFaunoImageUrl from './assets/el-laberinto-del-fauno.jpg';
import elLaberintoDelFaunoPreviewUrl from './assets/el-laberinto-del-fauno-preview.png';
import elOrfanatoImageUrl from './assets/el-orfanato.jpg';
import laComunidadImageUrl from './assets/la-comunidad.jpg';
import laIslaMinimaImageUrl from './assets/la-isla-minima.jpg';
import laLenguaDeLasMariposasImageUrl from './assets/la-lengua-de-las-mariposas.jpg';
import losOjosDeJuliaImageUrl from './assets/los-ojos-de-julia.jpg';
import marAdentroImageUrl from './assets/mar-adentro.jpg';
import ochoApellidosVascosImageUrl from './assets/ocho-apellidos-vascos.jpg';
import ochoApellidosVascosPreviewUrl from './assets/ocho-apellidos-vascos-preview.png';
import recImageUrl from './assets/rec.jpg';
import tesisImageUrl from './assets/tesis.jpg';
import todoSobreMiMadreImageUrl from './assets/todo-sobre-mi-madre.jpg';
import volverImageUrl from './assets/volver.jpg';

const images = {
  posters: {
    'abre-los-ojos-1997': abreLosOjosImageUrl,
    'celda-211-2009': celda211ImageUrl,
    'el-hijo-de-la-novia-2001': elHijoDeLaNoviaImageUrl,
    'el-laberinto-del-fauno-2006': elLaberintoDelFaunoImageUrl,
    'el-orfanato-2007': elOrfanatoImageUrl,
    'la-comunidad-2000': laComunidadImageUrl,
    'la-isla-minima-2014': laIslaMinimaImageUrl,
    'la-lengua-de-las-mariposas-1999': laLenguaDeLasMariposasImageUrl,
    'los-ojos-de-julia-2010': losOjosDeJuliaImageUrl,
    'mar-adentro-2004': marAdentroImageUrl,
    'ocho-apellidos-vascos-2014': ochoApellidosVascosImageUrl,
    'rec-2007': recImageUrl,
    'tesis-1996': tesisImageUrl,
    'todo-sobre-mi-madre-1999': todoSobreMiMadreImageUrl,
    'volver-2006': volverImageUrl,
  },
  previews: {
    'el-laberinto-del-fauno-2006': elLaberintoDelFaunoPreviewUrl,
    'ocho-apellidos-vascos-2014': ochoApellidosVascosPreviewUrl,
  },
};

export const spanishMovies = prepareMoviesData(spanishMoviesJSON, images);

export const spanishMoviesForEnUs = prepareMoviesData(
  getMoviesJsonForEnUs(spanishMoviesJSON),
  images,
);
